import { jsx as o } from "react/jsx-runtime";
import { tv as f } from "tailwind-variants";
const s = f({
  base: [
    "font-secondary",
    "font-semibold",
    "grow",
    "px-3",
    "py-1",
    "relative",
    "text-neutral-500",
    "whitespace-nowrap",
    "after:absolute",
    "after:bg-neutral-300",
    "after:h-[2px]",
    "after:left-0",
    "after:opacity-0",
    "after:top-[calc(100%-2px)]",
    "after:transition-opacity",
    "after:w-full",
    "disabled:opacity-50"
  ],
  variants: {
    isActive: {
      true: ["text-blue-500", "after:bg-blue-500", "after:opacity-100"]
    }
  }
}), p = ({ children: t, disabled: e, isActive: a, onClick: r }) => /* @__PURE__ */ o(
  "button",
  {
    className: s({ isActive: a }),
    disabled: e,
    onClick: r,
    type: "button",
    children: t
  }
);
export {
  p as default
};
